var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstNum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.9,218.73c45.93-31.79,70-80.41,91.69-130.32L216,77.16A2014.52,2014.52,0,0,1,188.3,285.34q-4.59,24.51-9.79,48.9c-2.48,11.67-3.17,33.46-11.71,42.53-6.46,6.85-21.57,8.25-30,11.78-12.1,5.06-20.93,11.95-28.27,22.87-14.09,21,18,45.68,35,27,31-34,88.13-41.42,124.83-11.49,22.06,18,53.79-13.39,31.53-31.53C245,350.7,160.59,353.67,112,406.91l35,27c4.83-7.19,20.3-8.75,27.74-11.66,12.16-4.76,23-11.39,30.3-22.49,9.18-13.89,11.62-31.18,15.08-47.17q6-27.63,11.19-55.4a2132.53,2132.53,0,0,0,29.33-220c1.73-21.3-32.78-31.47-41.54-11.25-18,41.54-37.14,87.64-75.69,114.32-23.44,16.23-1.17,54.89,22.5,38.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395,397.24a21.71,21.71,0,0,0,20.56-13.83,16.9,16.9,0,0,0,1.94-8.67c-.26-5.82-2.17-11.85-6.59-15.91A23.38,23.38,0,0,0,395,352.24a21.71,21.71,0,0,0-20.56,13.83,16.9,16.9,0,0,0-1.94,8.67c.26,5.82,2.17,11.86,6.59,15.91A23.38,23.38,0,0,0,395,397.24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstNum);
export default __webpack_public_path__ + "static/media/firstNum.9fcfa6057a6900e9d72562d7de32bf15.svg";
export { ForwardRef as ReactComponent };